import axios from "axios";
import $store from "../store";
import toLogin from "@libs/login";
import {
  VUE_APP_API_URL,
  hostnameOf,
  isLoopbackHost,
  sameSiteHost
} from "@utils/index";
import { getErrorMsg } from "@utils/dialog";

function resolveBaseURL() {
  if (typeof window !== "undefined" && isLoopbackHost(window.location.hostname)) {
    return "";
  }

  let fwqs = $store.state.app.fwq;
  if (fwqs == "null" || fwqs == null || !fwqs) {
    fwqs = VUE_APP_API_URL;
  }
  fwqs = String(fwqs || "").trim().replace(/\/+$/, "");
  if (!fwqs) {
    return "";
  }

  const fwqHost = hostnameOf(fwqs);
  if (!fwqHost || isLoopbackHost(fwqHost)) {
    return "";
  }
  if (
    typeof window !== "undefined" &&
    sameSiteHost(fwqHost, window.location.hostname)
  ) {
    return "";
  }

  if (/^(https?:\/\/|\/)/i.test(fwqs)) {
    return fwqs;
  }
  return "http://" + fwqs;
}

function rejectWithMsg(err, fallback) {
  const msg = getErrorMsg(err, fallback);
  return Promise.reject({
    msg,
    response: {
      data: {
        msg
      },
      status: (err && err.response && err.response.status) || 0
    }
  });
}

const defaultOpt = { login: true };

function baseRequest(options) {
  const isDev = process.env.NODE_ENV !== "production";
  const baseURL = resolveBaseURL();

  const instance = axios.create({
    baseURL,
    timeout: 30000
  });

  const token = $store.state.app.token || "";

  const headers = options.headers || {};
  headers["token"] = token;
  headers["Content-Type"] = "application/json";
  headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
  headers["Pragma"] = "no-cache";
  options.headers = headers;

  if (String(options.method || "").toLowerCase() === "get") {
    options.params = Object.assign({}, options.params || {}, {
      _t: Date.now()
    });
  }

  if (options.login && !token) {
    toLogin();
    return Promise.reject({
      msg: "未登录",
      toLogin: true,
      response: {
        data: {
          msg: "未登录"
        }
      }
    });
  }

  console.log("请求环境：", isDev ? "本地" : "生产");
  console.log("请求地址：", baseURL || "http://localhost:8080");
  console.log("请求路径：", options.url);

  return instance(options)
    .then(res => {
      return Promise.resolve(res);
    })
    .catch(err => {
      console.log("接口错误：", err);

      if (!err || !err.response) {
        return rejectWithMsg(err, "当前网络异常");
      }

      if (err.response.status == 401) {
        toLogin();
        return rejectWithMsg(err, "请先登录");
      }
      if (err.response.status == 429) {
        return rejectWithMsg(err, "操作频繁");
      }

      return rejectWithMsg(err, "当前网络异常");
    });
}

const request = ["post", "put", "patch"].reduce((request, method) => {
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign(
        {
          url,
          data,
          method
        },
        defaultOpt,
        options
      )
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign(
        {
          url,
          params,
          method
        },
        defaultOpt,
        options
      )
    );
  };
});

export default request;
